import { Routes } from '@angular/router';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { WelcomePageComponent } from './components/welcome-page/welcome-page.component';
import { RollingPageComponent } from './components/rolling-page/rolling-page.component';
import { VerificationPageComponent } from './components/verification-page/verification-page.component';
import {
  VerificationTractorsPageComponent
} from './components/verification-tractors-page/verification-tractors-page.component';
import { CoveragePageComponent } from './components/coverage-page/coverage-page.component';
import { CoverageProposalPageComponent } from './components/coverage-proposal-page/coverage-proposal-page.component';
import {
  EnrollmentConfirmationPageComponent
} from './components/enrollment-confirmation-page/enrollment-confirmation-page.component';
import { AuthGuardService } from './services/authGuardService';
import { ForgotPasswordPageComponent } from './components/forgot-password-page/forgot-password-page.component';
import { ResetPasswordPageComponent } from './components/reset-password-page/reset-password-page.component';
import { ResetPasswordGuardService } from './services/resetPasswordGuardService';
import { HomePageComponent } from './components/home-page/home-page.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { DocumentsPageComponent } from './components/documents-page/documents-page.component';
import { AnalyticsPageComponent } from './components/analytics-page/analytics-page.component';

export const ROUTES: Routes = [
  { path: '', component: LoginPageComponent },
  { path: 'home', component: HomePageComponent },
  { path: 'error', component: ErrorPageComponent },
  { path: 'confirmEmail', component: WelcomePageComponent },
  { path: 'rolling', component: RollingPageComponent },
  {
    path: 'forgot-password',
    component: ForgotPasswordPageComponent
  },
  {
    path: 'password-reset',
    component: ResetPasswordPageComponent,
    canActivate: [ResetPasswordGuardService]
  },
  {
    path: 'verification',
    component: VerificationPageComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'verification-tractors',
    component: VerificationTractorsPageComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'coverage',
    component: CoveragePageComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'coverage-proposal',
    component: CoverageProposalPageComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'documents',
    component: DocumentsPageComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'enrollment-confirmation',
    component: EnrollmentConfirmationPageComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'analytics',
    component: AnalyticsPageComponent,
    canActivate: [AuthGuardService]
  },
  { path: '**',
    component: CoveragePageComponent,
    canActivate: [AuthGuardService]
  },
];
